import React  from 'react';
import { RootStoreContext } from '@uplift/contexts';
import type { RootStore } from '@uplift/store';

export const RootStoreProvider: React.FC<{ rootStore: RootStore }> = ({
  rootStore,
  children,
}) => {
  return (
    <RootStoreContext.Provider value={rootStore}>
      {children}
    </RootStoreContext.Provider>
  );
};
